var amt_admin = require("amt_admin").default;
var app = require("angular").module("ww2_analytics.buildings", [amt_admin]);

var activity_tpl = require('./activity.html');


app.config([
  "$stateProvider",
  function ($stateProvider) {
    $stateProvider.state("amt.ww2.buildings", {
      url: "/buildings",
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 801,
        title: "Buildings",
        role: "buildings"
      },
      menu: {
        glyphicon: 'text-background',
        childs: [
          {
            state: "amt.ww2.buildings.activity",
            glyphicon: "flash"
          },
        ]
      }
    })
      .state('amt.ww2.buildings.activity', {
        url: '/activity',
        template: activity_tpl,
        reloadOnSearch: false,
        data: {
          priority: 801,
          title: 'Start build by days',
          role: 'buildings'
        }
      })
  }
]);

export default app.name;
